module.exports = __webpack_public_path__ + "img/filter.c7d34877.jpg";